module.exports = __webpack_public_path__ + "static/sketchconfetti@2x.42bff281.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sketchconfetti@2x.png
// module id = 449
// module chunks = 114276838955818